import { render, staticRenderFns } from "./PasswordFind.vue?vue&type=template&id=f3a008fa&scoped=true&"
import script from "./PasswordFind.vue?vue&type=script&lang=ts&"
export * from "./PasswordFind.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordFind.vue?vue&type=style&index=0&id=f3a008fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a008fa",
  null
  
)

export default component.exports